"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.store = undefined;

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _reactDom = require("react-dom");

var ReactDOM = _interopRequireWildcard(_reactDom);

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _reactRouterRedux = require("react-router-redux");

var _configureStore = require("./store/configureStore");

var _configureStore2 = _interopRequireDefault(_configureStore);

var _routes = require("./routes");

var _routes2 = _interopRequireDefault(_routes);

var _Internationalization = require("./containers/Internationalization");

var _Internationalization2 = _interopRequireDefault(_Internationalization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var store = exports.store = (0, _configureStore2.default)(_reactRouter.hashHistory); // initialState can be passed as 2nd argument here if needed
var enhancedHistory = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.hashHistory, store);
// Required for replaying actions from external devtools to work
// reduxRouterMiddleware.listenForReplays(store);
if (__DEVELOPMENT__) {
    window.store__ = store; // make the store available in the global browser scope
    window.React = React; // enable react debugger tools
    window.actions__ = require("./reducers/rootReducerActionsMap")(store.dispatch); // make the bound actions available in the global browser scope
    // enable the react-performance utilities, see https://facebook.github.io/react/docs/perf.html
    window.Perf = require("react-addons-perf");
}
var routes = (0, _routes2.default)(store);
var appWrapperClassName = "app-wrapper";
var AppWrapper = React.createClass({
    displayName: "AppWrapper",
    render: function render() {
        return React.createElement("div", { className: appWrapperClassName }, React.createElement(_reactRedux.Provider, { store: store, key: "provider" }, React.createElement(_Internationalization2.default, null, React.createElement("div", null, React.createElement(_reactRouter.Router, { history: enhancedHistory }, routes)))));
    }
});
ReactDOM.render(React.createElement(AppWrapper, null), document.getElementById("app")); // attach the app


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app.tsx
 ** module id = 629
 ** module chunks = 0
 **/